import Swal from "sweetalert2";
export const sweetAlert = (messageType, message) => {
  Swal.fire({
    icon: messageType,
    title: message,
    showConfirmButton: false,
    timer: 3000,
  });
};
